import { cn } from '@dreamstack/util/src/cn'

export const VeryLightGrayBox = ({
  className,
  ...rest
}: React.ComponentProps<'div'>) => (
  <div
    {...rest}
    className={cn(
      'bg-accentroAquaVeryLight-full text-px-20 col-span-full px-px-16 py-px-24 md:p-px-32 flex flex-col items-start gap-px-24',
      className
    )}
  />
)
